import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Scss = () =>{
    function calcHeight(nbLine){
        let calc = 19*nbLine
        return calc+"px"
        }
    return(
    
        <div id="articleContent" className="scss">
                 <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="css"
                    theme="monokai"
                    value={`//______________LES IMPORTS ________________//
@import "../mixins/variables";
//________________ EXEMPLE DE BOUCLE ________________//
$mediaqueries : (
  "Phone" 0px #355070,
  "Landscape Phones" 556px #6d597a,
  "Tablet" 768px #b56576,
  "Desktop" 992px #e56b6f,
  "Large" 1200px #eaac8b,
);

@each $device, $size, $bgcolor in $mediaqueries {
  @media (min-width: $size) { 
    #root::after{
      position: fixed;
      top:0;
      left: 0;
      background-color:$bgcolor;
      padding: 0.5rem;
      color:#fff;
      font-size: 1rem;
      letter-spacing: 0.5rem;
      content:$device;
    }
  }
}
body {
  @include bounce(
    $duration: 1s, /*durée de l'animation*/
    $count: 2, /*Nombre de fois ou c'est animé*/
    $delay: .2s,/*Delai avant démarrage de l'animation*/
    $function: ease, /*fonction dont l'animation se déroule au fur et a mesure animation-timing-function*/
    $fill: both /*animation-fill-mode*/
  );
}
//________________ LES VARIABLES ________________//
/*Variable classique à une valeur*/
$var-color:#11af82;
$var-shadow-size : 0.2rem;
/*Variables liste (différentes syntaxes possibles)*/
$var-padding: 1rem 2rem 3rem 4rem;
$var-padding: 1rem,2rem,3rem,4rem;
$var-padding: (1rem 2rem 3rem 4rem);
$var-padding: (1rem,2rem,3rem,4rem);
/*Variable Map*/
$var-font-size: (title-h1:7rem, title-h2:5rem, paragraph:2rem, label:1rem);
/* >>>>>>> Exemple d'utilisation des variables*/
.sass2{
    color:$var-color;
    padding:nth($var-padding, 4); // nth() pour les listes
    font-size:map-get($var-font-size, title-h1); // map-get() pour les maps
}

//_______________ LES MIXINS ________________//
@mixin bloc-shadow{
    box-shadow: 0 0 0.05rem 0.05rem #15DEA5;
    }
/*Avec fonctions*/
@mixin heading-shadow($colour:$var-color, $size: $var-shadow-size){
    text-shadow: $size $size darken($colour, 10%);
    }
/* >>>>>>> Exemple d'utilisation des mixins*/
.sass3{
    @include heading-shadow; // @include
    }
    
//_______________ LES EXTENSIONS (affecte l'organisation des css) ________________//
/*En déclarant un selecteur*/
.typography{ 
    color:green;
    font-size: 2rem;
    padding: 1rem;
}
/*Sans déclarer un selecteur (avec un placeholder)*/
%typography{ 
    color:black;
    font-size: 2rem;
    padding: 1rem;
}
// >>>>>> Exemple d'utilisation des extensions
div{
    @extend .typography;
}
p{
    @extend .typography;
}
div{
    @extend %typography;
}
p{
    @extend %typography;
}

// ___________ LES CONDITIONS______________//
@mixin background($bg){
    background-color: $bg;
    @if($bg == #000){
        color:#fff;
    }@else{
        color:#000;
    }
}
/*Autre exemple de condition avec hsl : hue, saturation, lightness
@if ( lightness($colour) < 25% ) or ( saturation($colour) > 10% ) {...}
@if ( lightness($colour) < 25% ) and ( lightness($colour) > 10% ) {...} 
*/
.condition {
@include background(#000)
}

// __________LES FONCTIONS___avec Mixin______________//
@function lightness-shift($colour){
    @if ( lightness($colour) < 25% ) {
        @return lighten($colour, 20%);
    }@else{
          @return darken($colour, 20%);
        }
    }
@mixin heading-shadow($colour, $size){
    font-size: 5rem;
    font-weight: bold;
    color:$colour;  
    text-shadow:$size $size lightness-shift($colour);
    }
.fonction{
    @include heading-shadow(hsl(0, 100%, 50%),.50rem)
}

$var-random-color : rgb(random(255),random(255),random(255));
.fonction1{color:$var-random-color}

$var-largeur : 1440;
.fonction2{margin : 0 round($var-largeur/100)+px} 

$var-color : #005183;
$var-secondary-color : adjust-color(#005183,$red: 100,$green: 0,$blue: 0,$alpha: 1);
$var-secondary-color : adjust-color(#005183,$hue: 100, $saturation: 0, $lightness: 0, $alpha: 1);
.fonction3{color:$var-secondary-color}

// __________LES MAP___avec Mixin______________//
$colour-primary: #15DEA5;
$colour-secondary: #001534;
$colour-accent: #D6FFF5;
$colour-white: #fff;
$colour-invalid: #DB464B;
$txt-link-palette:(
    link:(
        bg:$colour-white
    ),
    visited:(
        bg:$colour-accent
    ),
    hover:(
        bg:$colour-primary
    ),
    active:(
        bg:$colour-invalid
    )
);
@mixin txt-input-palette($state) {
    $palette: map-get($txt-link-palette, $state);
    background-color: map-get($palette, bg);
    }
    
ul.first li{
  @include txt-input-palette(hover);
}
// __________LES BOUCLES___avec Mixin______________//

/*for*/
@for $i from 1 through 2 {
    .grid-#{$i} {
        width: 100px*$i;
    }
}
/*while*/
$i: 3;

@while $i > 0 {
    .item-#{$i} { width: 2em * $i; }
    $i: $i - 2;
}
/*each*/
@each $animal in puma, cat, dog{
    .#{$animal}-icon {
      background-image: url('/images/#{$animal}.png');
    }
}

$link-exemple:(
    link:(
        bg:#000
    ),
    hover:(
        bg:#ddd
    )
);

@mixin test($palettes) {
    @each $state, $palette in $palettes{
        &:#{$state}{
        background-color: map-get($palette, bg);
        }
    }
}


ul.last li{
    @include test($link-exemple);
}`}
                    height={calcHeight(211)}
                    width="100%"
                  />
                </code>
                </pre>








                <pre>
                <code>
                <AceEditor
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="css"
                    theme="monokai"
                    value={`@charset "UTF-8";
//________________ EXEMPLE DE BOUCLE ________________//
@media (min-width: 0px) {
  #root::after {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #355070;
    padding: 0.5rem;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 0.5rem;
    content: "Phone";
  }
}
@media (min-width: 556px) {
  #root::after {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #6d597a;
    padding: 0.5rem;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 0.5rem;
    content: "Landscape Phones";
  }
}
@media (min-width: 768px) {
  #root::after {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #b56576;
    padding: 0.5rem;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 0.5rem;
    content: "Tablet";
  }
}
@media (min-width: 992px) {
  #root::after {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #e56b6f;
    padding: 0.5rem;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 0.5rem;
    content: "Desktop";
  }
}
@media (min-width: 1200px) {
  #root::after {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #eaac8b;
    padding: 0.5rem;
    color: #fff;
    font-size: 1rem;
    letter-spacing: 0.5rem;
    content: "Large";
  }
}
/*Variable classique à une valeur*/
/*Variables liste (différentes syntaxes possibles)*/
/*Variable Map*/
/* >>>>>>> Exemple d'utilisation des variables*/
.sass2 {
  color: #11af82;
  padding: 4rem;
  font-size: 7rem;
}


/*Avec fonctions*/
/* >>>>>>> Exemple d'utilisation des mixins*/
.sass3 {
  text-shadow: 0.2rem 0.2rem #0c815f;
}

/*En déclarant un selecteur*/
.typography, p, div {
  color: green;
  font-size: 2rem;
  padding: 1rem;
}

/*Sans déclarer un selecteur (avec un placeholder)*/
p, div {
  color: black;
  font-size: 2rem;
  padding: 1rem;
}

/*Autre exemple de condition avec hsl : hue, saturation, lightness
@if ( lightness($colour) < 25% ) or ( saturation($colour) > 10% ) {...}
@if ( lightness($colour) < 25% ) and ( lightness($colour) > 10% ) {...} 
*/
.condition {
  background-color: #000;
  color: #fff;
}

.fonction {
  font-size: 5rem;
  font-weight: bold;
  color: red;
  text-shadow: 0.5rem 0.5rem #990000;
}

.fonction1 {
  color: #a880ce;
}

.fonction2 {
  margin: 0 14px;
}

.fonction3 {
  color: #83007d;
}

ul.first li {
  background-color: #15DEA5;
}

/*for*/
.grid-1 {
  width: 100px;
}

.grid-2 {
  width: 200px;
}

/*while*/
.item-3 {
  width: 6em;
}

.item-1 {
  width: 2em;
}

/*each*/
.puma-icon {
  background-image: url("/images/puma.png");
}

.cat-icon {
  background-image: url("/images/cat.png");
}

.dog-icon {
  background-image: url("/images/dog.png");
}

ul.last li:link {
  background-color: #000;
}
ul.last li:hover {
  background-color: #ddd;
}/*# sourceMappingURL=index.css.map */`}
                    height={calcHeight(168)}
                    width="100%"
                  />
                </code>
                </pre>
        </div>
    )
}
